import React from 'react';

const typeFilters = [
  { id: 'photo', label: 'Fotos' },
  { id: 'video', label: 'Vídeos' },
];

const orientationFilters = [
  { id: '', label: 'Todos' },
  { id: 'landscape', label: 'Landscape' },
  { id: 'portrait', label: 'Portrait' },
  { id: 'square', label: 'Square' },
];

export default function MediaFilters({ type, orientation, onTypeChange, onOrientationChange }) {
  return (
    <div className="mp-media-picker-filters">
      <div className="mp-media-picker-filters__group" role="tablist" aria-label="Tipo de mídia">
        {typeFilters.map((filter) => (
          <button
            key={filter.id}
            type="button"
            role="tab"
            aria-selected={type === filter.id}
            className={`mp-media-picker-filters__btn ${type === filter.id ? 'is-active' : ''}`}
            onClick={() => onTypeChange(filter.id)}
          >
            {filter.label}
          </button>
        ))}
      </div>

      <div className="mp-media-picker-filters__group" role="tablist" aria-label="Orientação">
        {orientationFilters.map((filter) => (
          <button
            key={filter.id || 'all'}
            type="button"
            role="tab"
            aria-selected={orientation === filter.id}
            className={`mp-media-picker-filters__btn ${orientation === filter.id ? 'is-active' : ''}`}
            onClick={() => onOrientationChange(filter.id)}
          >
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  );
}
